import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import EditorCloseIcon from '@atlaskit/icon/glyph/editor/close';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type RemoveViewProps = {
	onRemove: () => void;
	day: string;
};

const RemoveView = ({ onRemove, day = '' }: RemoveViewProps) => {
	const { formatMessage } = useIntl();
	return (
		<RowActiveCellWrapper
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className="row-active-cell-wrapper"
		>
			<Button
				testId="servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.remove.button"
				appearance="subtle"
				iconAfter={<EditorCloseIcon label="" />}
				onClick={onRemove}
				aria-label={formatMessage(messages.remove, { day })}
			/>
		</RowActiveCellWrapper>
	);
};

export const Remove = RemoveView;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const RowActiveCellWrapper = styled.div<{ isActive?: boolean }>((props) => ({
	cursor: 'pointer',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	opacity: props.isActive ? 1 : 0,
	'&:hover, &:focus': {
		opacity: 1,
	},
	'&:focus-within': {
		opacity: 1,
	},
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export const WithRowsActiveCellBase = styled.div({
	'&:focus, &:hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'& .row-active-cell-wrapper': {
			opacity: 1,
		},
	},

	/* this is separate from the two above because Edge won't apply the :hover or :focus styles with :focus-within
        in the same style statement (because it doesn't support focus-within and so ignores the entire selector) */
	'&:focus-within': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'& .row-active-cell-wrapper': {
			opacity: 1,
		},
	},
});
